import Box from '@mui/material/Box'
import AuthCardWrapper from 'auth/shared/AuthCardWrapper'
import { observer } from 'mobx-react-lite'
import CenterFullScreen from 'reusable/mui/utilities/CenterFullScreen'
import { useAuthShareStore } from './AuthShareStore'
import TextField from '@mui/material/TextField'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import FlexAlignRight from 'reusable/mui/utilities/FlexAlignRight'
import ArrowRightAltOutlined from '@mui/icons-material/ArrowRightAltOutlined'

export default observer(function AuthShareNames() {
   const authShareStore = useAuthShareStore()

   return <CenterFullScreen>
      <AuthCardWrapper title="Please enter your name" subtitle="So we know which responses are yours.">
         <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ flex: 1, mr: 1 }}>
               {authShareStore.formHandler.firstName.bindInput(ip =>
                  <TextField
                     variant="outlined"
                     label="First name*"
                     fullWidth
                     {...ip}
                  />
               )}
            </Box>
            <Box sx={{ flex: 1 }}>
               {authShareStore.formHandler.lastName.bindInput(ip =>
                  <TextField
                     variant="outlined"
                     label="Last name*"
                     fullWidth
                     {...ip}
                  />
               )}
            </Box>
         </Box>
         <FlexAlignRight>
            <AuthShareContinueButton />
         </FlexAlignRight>
      </AuthCardWrapper>
   </CenterFullScreen>
})

const AuthShareContinueButton = observer(function AuthShareContinueButton() {
   const authShareStore = useAuthShareStore()
   return <ButtonWithProgress
      loading={authShareStore.loader.isLoading}
      variant="contained"
      icon={<ArrowRightAltOutlined />}
      disabled={!authShareStore.canContinue}
      onClick={authShareStore.setNamesAndContinue}
      sx={{ whiteSpace: 'nowrap', mt: 6 }}
   >
      Continue
   </ButtonWithProgress>
})
